import { Tag } from "components/DesignSystem/Tag/Tag";

type AmendmentTagProps = {
  amendmentNumber?: number;
};

export const AmendmentTag = ({ amendmentNumber }: AmendmentTagProps) => {
  if (!amendmentNumber) return null;

  return (
    <Tag tagType="purple" icon={false} size="small" rounded>
      Amendment {amendmentNumber}
    </Tag>
  );
};
